export const createSingleChatId = (
  userId: string,
  partnerId: string,
): string => {
  if (parseInt(userId) < parseInt(partnerId)) return userId + "_" + partnerId;
  return partnerId + "_" + userId;
};
